import { render } from "./Logo.vue?vue&type=template&id=20cad366"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"

import "./Logo.vue?vue&type=style&index=0&id=20cad366&lang=scss"

import exportComponent from "/home/forge/deployments/control-center.conneqt.io/new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__